import React, { FC, useCallback, useEffect, useState } from 'react';
import type { ICellRendererParams } from 'ag-grid-community';

import { loadAgreementByIdFetch } from '../../../app/axios/agreementFetches';
import HLHoverPopover from '../../../shared/components/popover/HLHoverPopover';
import popoverClasses from '../../../shared/components/popover/HLHoverPopover.module.scss';
import { AgreementStudentStructure, AgreementView } from '../../../shared/types/agreement';

const AgreementLessonPriceCell: FC<ICellRendererParams<AgreementView>> = ({value, data}) => {
    const [students, setStudents] = useState<AgreementStudentStructure[] | null>(null);

    useEffect(() => {
        setStudents(null);
    }, [data?.id]);

    const loadStudents = useCallback(() => {
        if (!data?.id) return;

        loadAgreementByIdFetch(data.id)
            .then(agreement => setStudents(agreement.students))
            .catch(err => console.error('Ошибка при загрузке учеников договора:', err));
    }, [data?.id]);

    const renderContent = () => {
        if (!students?.length) {
            return <div className={popoverClasses.empty}>Нет учеников</div>;
        }

        return (
            <div className={popoverClasses.list}>
                {students.map(student => (
                    <div key={student.id} className={popoverClasses.item}>
                        <span className={popoverClasses.name}>
                            {student.firstName} {student.lastName || ''}
                        </span>
                        <span className={popoverClasses.price}>{student.lessonPrice} ₽</span>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <HLHoverPopover content={renderContent()} onShow={loadStudents}>
            {value ? `${value} ₽` : ''}
        </HLHoverPopover>
    );
};

export default AgreementLessonPriceCell;
